import { configureStore } from '@reduxjs/toolkit';
import trainingModelReducer from './traningModelAi';

const store = configureStore({
  reducer: {
    trainingModel: trainingModelReducer,
  },
});

export default store;
